// In-browser face engine (free) using @vladmandic/face-api.
// Used for 1:1 face verification: enroll an employee's face descriptor once,
// then match it at attendance time. Models are served from /public/models.
import * as faceapi from '@vladmandic/face-api';

const MODEL_URL = '/models';
let _loadingPromise = null;
let _loaded = false;

export async function loadFaceModels() {
  if (_loaded) return;
  if (_loadingPromise) return _loadingPromise;
  _loadingPromise = (async () => {
    await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
    await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
    await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
    _loaded = true;
  })();
  return _loadingPromise;
}

// Returns a 128-d descriptor array for the single largest face, or null.
export async function getFaceDescriptor(input) {
  await loadFaceModels();
  const detection = await faceapi
    .detectSingleFace(input, new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.5 }))
    .withFaceLandmarks()
    .withFaceDescriptor();
  if (!detection) return null;
  return Array.from(detection.descriptor);
}

export function euclideanDistance(a, b) {
  let sum = 0;
  for (let i = 0; i < a.length; i++) {
    const d = a[i] - b[i];
    sum += d * d;
  }
  return Math.sqrt(sum);
}

// Match a probe descriptor against a set of enrolled descriptors.
// Returns { matched, distance } using the standard 0.6 threshold (lower = stricter).
export function matchDescriptor(probe, enrolledList, threshold = 0.55) {
  let best = Infinity;
  for (const d of enrolledList || []) {
    const dist = euclideanDistance(probe, d);
    if (dist < best) best = dist;
  }
  return { matched: best <= threshold, distance: best };
}
